"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrianglePainter = void 0;
var ShapePainter_1 = require("../ShapePainter");
var round_1 = require("../../../util/round");
var antiAliasSize = 1;
/**
 * Implements drawing-related operations for triangles. Known minor issue: the paint
 * size calculation is not exact for objects with strokes. The calculated size can be
 * way too large. This only impacts rendering performance a little.
 */
var TrianglePainter = /** @class */ (function (_super) {
    __extends(TrianglePainter, _super);
    function TrianglePainter() {
        var _this = _super.call(this, "triangle") || this;
        _this.baseWidthOf = function (object) { return object.width; };
        _this.baseHeightOf = function (object) { return object.height; };
        return _this;
    }
    TrianglePainter.prototype.tracePath = function (ctx, store, object) {
        ctx.beginPath();
        var topMiddle = {
            x: 0.5 * this.scaledBaseWidthOf(object),
            y: 0
        };
        var bottomRight = {
            x: round_1.round(object, this.scaledBaseWidthOf(object)) - antiAliasSize,
            y: round_1.round(object, this.scaledBaseHeightOf(object)) - antiAliasSize
        };
        var bottomLeft = {
            x: antiAliasSize,
            y: round_1.round(object, this.scaledBaseHeightOf(object)) - antiAliasSize
        };
        ctx.moveTo(topMiddle.x, topMiddle.y);
        ctx.lineTo(bottomRight.x, bottomRight.y);
        ctx.lineTo(bottomLeft.x, bottomLeft.y);
        ctx.closePath();
    };
    TrianglePainter.prototype.needsMiterOvershoot = function (object) {
        return true;
    };
    return TrianglePainter;
}(ShapePainter_1.ShapePainter));
exports.TrianglePainter = TrianglePainter;
//# sourceMappingURL=TrianglePainter.js.map